import { post } from '@core/api/baseApi';

export const addSolicitation = async (payload: FormData, studyInstanceUid: string): Promise<void> => {
  await post(`/studies/${studyInstanceUid}/solicitation`, payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

